import escapeRegExp from 'escape-string-regexp';
import { h } from 'vue';

export default {
  props: {
    text: { type: String, default: '' },
  },
  data: () => ({
    container: null,
  }),
  computed: {
    regexp() {
      return this.text.trim() ? new RegExp(escapeRegExp(this.text), 'gi') : null;
    },
  },
  watch: {
    regexp: 'highlight',
  },
  methods: {
    highlight() {
      Array.from(this.$el.querySelectorAll('span.matched'))
        .forEach((mark) => {
          const parent = mark.parentNode;
          parent.replaceChild(mark.firstChild, mark);
          parent.normalize();
        });

      if (!this.regexp) {
        this.$emit('noMatch');
        return;
      }

      let isMatched = false;
      Array.from(this.$el.childNodes).forEach(function mark(node) {
        if (node.nodeType === 3 && node.data.trim() && this.regexp.test(node.data)) {
          node.parentNode.replaceChild(this.createHighlightNodes(node.data), node);
          isMatched = true;
        } else if (node.nodeType === 1) {
          Array.from(node.childNodes).forEach(mark, this);
        }
      }, this);

      this.$emit(isMatched ? 'matched' : 'noMatch');
    },
    createHighlightNodes(text) {
      const fragment = document.createDocumentFragment();

      this.container = this.container || document.createElement('div');
      this.container.innerHTML = text.replace(
        this.regexp,
        (matched) => `<span class="matched">${matched}</span>`,
      ).trim();

      Array.from(this.container.childNodes).forEach((child) => fragment.appendChild(child));

      return fragment;
    },
  },
  render() {
    return h('div', {}, this.$slots.default ? this.$slots.default() : []);
  },
  mounted() {
    if (this.text) {
      this.highlight();
    }
  },
};
